import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

const RecipeDescription = ({ description }) => {
    const theme = useTheme();

    return (
        <Box sx={{ mb: theme.spacing(4) }}>
            <Typography 
                variant="h5" 
                gutterBottom 
                sx={{ 
                    color: theme.palette.primary.main,
                    fontWeight: theme.typography.fontWeightBold,
                    mb: theme.spacing(3),
                    position: 'relative',
                    '&:after': {
                        content: '""',
                        position: 'absolute',
                        bottom: theme.spacing(-1),
                        left: 0,
                        width: 60,
                        height: 3,
                        bgcolor: theme.palette.primary.main
                    }
                }}
            >
                Recipe Description
            </Typography>
            
            <Box sx={{
                lineHeight: theme.typography.body1.lineHeight,
                fontSize: theme.typography.body1.fontSize,
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
                '& p': { mb: theme.spacing(2) },
                '& ul': { pl: theme.spacing(3), mb: theme.spacing(2) },
                '& li': { mb: theme.spacing(1) }
            }}>
                {description ? (
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                ) : (
                    <Typography color={theme.palette.text.secondary}>
                        No description available for this recipe.
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

RecipeDescription.propTypes = {
    description: PropTypes.string
};

export default RecipeDescription;
